import { render, staticRenderFns } from "./work-shop.vue?vue&type=template&id=b020eb1c&scoped=true"
import script from "./work-shop.vue?vue&type=script&lang=js"
export * from "./work-shop.vue?vue&type=script&lang=js"
import style0 from "./work-shop.vue?vue&type=style&index=0&id=b020eb1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b020eb1c",
  null
  
)

export default component.exports